export const SET_OFFER_TO_SELLS = 'SET_OFFER_TO_SELLS'
export const ADD_INVOICE = 'ADD_INVOICE'
export const UPDATE_INVOICE = 'UPDATE_INVOICE'
export const DELETE_INVOICE = 'DELETE_INVOICE'
export const DELETE_MULTIPLE_INVOICES = 'DELETE_MULTIPLE_INVOICES'
export const SET_SELECTED_OFFERS = 'SET_SELECTED_OFFERS'
export const SET_TOTAL_OFFER_TO_SELLS = 'SET_TOTAL_OFFER_TO_SELLS'
export const RESET_CUSTOMER = 'RESET_CUSTOMER'
export const RESET_ITEM = 'RESET_ITEM'
export const SET_CUSTOMER = 'SET_CUSTOMER'
export const SET_ITEM = 'SET_ITEM'
export const SET_TEMPLATE_ID = 'SET_TEMPLATE_ID'
export const SELECT_CUSTOMER = 'SELECT_CUSTOMER'
export const RESET_SELECTED_CUSTOMER = 'RESET_SELECTED_CUSTOMER'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const RESET_SELECTED_OFFERS = 'RESET_SELECTED_OFFERS'
export const UPDATE_OFFER_TO_SELL_STATUS = 'UPDATE_OFFER_TO_SELL_STATUS'

export const ATTACHMENTS = 'ATTACHMENTS'
export const SET_TOTAL_ATTACHMENTS = 'SET_TOTAL_ATTACHMENTS'
export const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT'
export const SET_SELECTED_ATTACHMENTS = 'SET_SELECTED_ATTACHMENTS'
export const SET_SELECT_ALL_STATE_ATTACHMENT = 'SET_SELECT_ALL_STATE_ATTACHMENT'

export const SET_SELECTED_PREAPPROVED_INVOICE = 'SET_SELECTED_PREAPPROVED_INVOICE'
